import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { GlobalAuthProvider } from "./contexts/GlobalContext";
import { SupabaseUserProvider } from './contexts/SupabaseUserContext';


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <GlobalAuthProvider>
    <SupabaseUserProvider>
    <App />
    </SupabaseUserProvider>
  </GlobalAuthProvider>
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });
  });
}
